<template>
  <div
      class="battery"
      :class="[`battery--${size}`]"
  >
    <svg
        class="battery__svg"
        viewBox="0 0 84 40"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
      <rect
          x="2"
          y="5"
          width="72"
          height="30"
          rx="3"
          ry="3"
          fill="none"
          stroke="#8F8F8F"
          stroke-width="4"
      />
      <rect
          x="75"
          y="13"
          width="7"
          height="14"
          rx="2"
          ry="2"
          fill="#8F8F8F"
      />
    </svg>

    <div class="battery__fill-wrap">
      <div class="battery__fill" :style="fillStyle"></div>
    </div>

    <span v-if="showLabel" class="battery__label">
      {{ labelText }}
    </span>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'BatteryIndicator',

  props: {
    level: {
      type: Number,
      default: 100,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'default',
    },
  },

  setup(props) {
    const clampedLevel = computed(() => {
      if (props.level < 0) return 0
      if (props.level > 100) return 100
      return props.level
    })

    const gradientColors = computed(() => {
      if (clampedLevel.value <= 25) {
        return {
          start: '#FFD54F',
          middle: '#FF8A65',
          end: '#DCE775',
        }
      }

      if (clampedLevel.value <= 50) {
        return {
          start: '#DCE775',
          middle: '#FFD54F',
          end: '#7ED957',
        }
      }

      return {
        start: '#7ED957',
        middle: '#54C63A',
        end: '#31B237',
      }
    })

    const fillStyle = computed(() => {
      return {
        width: `${clampedLevel.value}%`,
        '--battery-start': gradientColors.value.start,
        '--battery-middle': gradientColors.value.middle,
        '--battery-end': gradientColors.value.end,
      }
    })

    const labelText = computed(() => {
      return props.label || `${clampedLevel.value}%`
    })

    return {
      fillStyle,
      labelText,
    }
  },
}
</script>

<style scoped>
.battery {
  position: relative;
  width: 84px;
  height: 40px;
  flex: 0 0 84px;
}

.battery__svg {
  position: absolute;
  inset: 0;
  width: 84px;
  height: 40px;
  display: block;
  z-index: 2;
  pointer-events: none;
}

.battery__fill-wrap {
  position: absolute;
  left: 8px;
  top: 11px;
  width: 59px;
  height: 18px;
  overflow: hidden;
  z-index: 1;
  background: #ececec;
}

.battery__fill {
  height: 100%;
  transition:
      width 0.35s cubic-bezier(0.4, 0, 0.2, 1),
      background 0.25s ease;
  background: linear-gradient(
      90deg,
      var(--battery-start) 0%,
      var(--battery-middle) 45%,
      var(--battery-end) 100%
  );
}

.battery__label {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #222;
  pointer-events: none;
}

.battery--small {
  width: 56px;
  height: 27px;
  flex: 0 0 56px;
}

.battery--small .battery__svg {
  width: 56px;
  height: 27px;
}

.battery--small .battery__fill-wrap {
  left: 5px;
  top: 7px;
  width: 39px;
  height: 12px;
}

.battery--small .battery__label {
  font-size: 10px;
}
</style>